<div class="version-warning-text select-none cursor-pointer" *ngIf="isWrongVersion" (click)="reload()">
  A new version of Vorto SANDi Lite is available. Please refresh to get the latest version of the app.
</div>
